<template>
  <div class="cemsPublicity" ref="cemsPublicity">
    <div class="div_outbox" v-show="list.length > 0">
      <div class="div_innerbox" v-for="(index, i) in listHandled" :key="i">
        <!-- <div class="boxbg"></div> -->
        <a
          :class="customerId == 38 ? 'boxbg hx_bg' : getCEMsBoxClass(index.deviceNo)"
          :id="'div_innerbox' + i"
          :ref="'div_id'"
          @click="getDetailPup(index.deviceNo, index)"
        >
          <div class="hover-bg"></div>
          <div class="name">
            <img src="./img/DIYtitleFont.png" />
            <span class="tinyName">
              {{
              index.name
              }}
            </span>
          </div>
          <div class="time">{{ index.time }}</div>
          <div class="txtContent">
            <div class="textTitle">
              <div class="title1">监测值</div>
              <div class="title2">排放标准</div>
            </div>
            <div class="textTable">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                  <td class="listName">SO2浓度</td>
                  <td>
                    <span :class="getRealDate(index.so2, index.gbSo2)">
                      {{
                      !isNaN(index.so2)
                      ? parseFloat(index.so2).toFixed(2)
                      : index.so2
                      }}
                    </span>
                    <span class="unit">mg/m3</span>
                  </td>
                  <td>
                    <span :class="getStandardDate">{{ index.gbSo2 }}</span>
                    <span class="unit">mg/m3</span>
                  </td>
                </tr>
                <tr>
                  <td class="listName">颗粒物浓度</td>
                  <td>
                    <span :class="getRealDate(index.klw)">
                      {{
                      !isNaN(index.klw)
                      ? parseFloat(index.klw).toFixed(2)
                      : index.klw
                      }}
                    </span>
                    <span class="unit">mg/m3</span>
                  </td>
                  <td>
                    <span :class="getStandardDate">{{ index.gbTdc }}</span>
                    <span class="unit">mg/m3</span>
                  </td>
                </tr>
                <tr>
                  <td class="listName">NOX浓度</td>
                  <td>
                    <span :class="getRealDate(index.nox)">
                      {{
                      !isNaN(index.nox)
                      ? parseFloat(index.nox).toFixed(2)
                      : index.nox
                      }}
                    </span>
                    <span class="unit">mg/m3</span>
                  </td>
                  <td>
                    <span :class="getStandardDate">{{ index.gbNox }}</span>
                    <span>mg/m3</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from 'vuex'
import iframePup from '@/modules/iframePup/iframePup.vue'
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { iframePup },
  props: ['matrix', 'x', 'y'],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      timer1: null,
      timer2: null,
      timer3: null,
      timer4: null,
      listTimer: null,
      animateTimer: null,
      list: [],
      listHandled: [[], [], [], [], [], []],
      selectDeviceNo: '',
      altitude: 0,
      flyAltitude: 0,
      curIndex: 0,
      preIndex: 6,
      isBaoSteel: bmeConfig.isBaoSteel
    }
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent'
    }),
    getCEMsBoxClass() {
      return function (deviceNo) {
        if (this.isBaoSteel) {
          if (this.selectDeviceNo === deviceNo) {
            return 'isBaoSteel boxbg cemsSel'
          } else {
            return 'isBaoSteel boxbg'
          }
        } else {
          if (this.selectDeviceNo === deviceNo) {
            return 'boxbg cemsSel'
          } else if (this.customerId == 89) {
            return 'boxbg box-bg-89'
          } else {
            return 'boxbg'
          }
        }
      }
    },
    getRealDate() {
      return function (num, gb) {
        let classVal = ''
        if (num <= gb * 1) {
          classVal = 'number blueColor'
        } else if (num <= gb * 3) {
          classVal = 'number yellowColor'
        } else if (num > gb * 3) {
          classVal = 'number redColor'
        } else {
          classVal = 'number normalColor'
        }
        return classVal
      }
    },
    getStandardDate() {
      return 'number normalColor'
    },
    getToFixedNumber() {
      return function (num) {
        let res = null
        if (num) {
          res = num.toFixed(2)
        }
        return res
      }
    }
  },
  //监控data中的数据变化
  watch: {
    listHandled: {
      handler(newVal) {
        this.startCEMSCardAnimate()
      },
      deep: true
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    let w = $(that.$refs.cemsPublicity).outerWidth()
    let h = $(that.$refs.cemsPublicity).outerHeight()
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y
    })
    this.altitude = bmeConfig.altitude || bmeConfig.altitude === 0 ? bmeConfig.altitude : 50
    this.flyAltitude = this.altitude < 150 ? 150 : this.altitude
    this.getCemsData()
  },
  unmounted() {
    if (this.animateTimer) {
      clearTimeout(this.animateTimer)
    }
    if (this.timer1) {
      clearTimeout(this.timer1)
    }
    if (this.timer2) {
      clearTimeout(this.timer2)
    }
    if (this.timer3) {
      clearTimeout(this.timer3)
    }
    if (this.timer4) {
      clearTimeout(this.timer4)
    }
    if (this.timer5) {
      clearTimeout(this.timer5)
    }
    if (this.listTimer) {
      clearTimeout(this.listTimer)
    }
  },
  //方法集合
  methods: {
    getCemsData() {
      console.log(111111)
      let that = this
      let findCemsListUrl = CONFIG.requestName + this.$apiOpt.findCemsList
      this.$apiUtils
        .get(findCemsListUrl, {
          customerId: this.$store.state.customerId
        })
        .then(function (data) {
          that.list = []
          if (data && data.length) {
            data &&
              data.forEach((element, n) => {
                that.list.push({
                  name: n + 1 + '. ' + element.deviceName,
                  deviceNo: element.deviceNo ? element.deviceNo : '',
                  so2: element.deviceSo2 ? that.getToFixedNumber(element.deviceSo2) : '--',
                  klw: element.deviceTdc ? that.getToFixedNumber(element.deviceTdc) : '--',
                  nox: element.deviceNox ? that.getToFixedNumber(element.deviceNox) : '--',
                  gbNox: element.gbNox ? element.gbNox : '--',
                  gbSo2: element.gbSo2 ? element.gbSo2 : '--',
                  gbTdc: element.gbTdc ? element.gbTdc : '--',
                  time: that.$moment(element.time).format('YYYY-MM-DD HH:mm'),
                  lon: element.longitude || 0,
                  lat: element.latitude || 0
                })
              })
            that.$forceUpdate()
            that.changeData(that.list)
          }
        })
    },
    changeData(newVal) {
      let time = 500
      let list = this.sliceList(newVal, 6)
      // let list = this.chunk(newVal, 6);
      let pageIndex = 0
      // this.pageChange(list, pageIndex, time);
    },
    pageChange(list, pageIndex, time) {
      console.log(list, 'list')
      let total = list.length
      let n = pageIndex % total
      let that = this
      if (this.timer1 || this.timer2 || this.timer3 || this.timer4) {
        clearTimeout(this.timer1)
        clearTimeout(this.timer2)
        clearTimeout(this.timer3)
        clearTimeout(this.timer4)
        this.timer1 = null
        this.timer2 = null
        this.timer3 = null
        this.timer4 = null
      }
      $('#div_innerbox0').fadeOut(2000, function () {
        that.listHandled[0] = list[n][0]
        $(this).fadeIn(2000)
      })

      this.timer1 = setTimeout(function () {
        $('#div_innerbox1').fadeOut(2000, function () {
          if (list[n][1]) {
            if (that.$refs.div_id1) {
              that.$refs.div_id1[0].style.opacity = 1
            }
            that.listHandled[1] = list[n][1]
          } else {
            if (that.$refs.div_id1) {
              that.$refs.div_id1[0].style.opacity = 0
            }
          }
          $(this).fadeIn(2000)
        })
        $('#div_innerbox2').fadeOut(2000, function () {
          if (list[n][2]) {
            if (that.$refs.div_id2) {
              that.$refs.div_id2[0].style.opacity = 1
            }
            that.listHandled[2] = list[n][2]
          } else {
            if (that.$refs.div_id2) {
              that.$refs.div_id2[0].style.opacity = 0
            }
          }
          $(this).fadeIn(2000)
        })
      }, time)

      this.timer2 = setTimeout(function () {
        $('#div_innerbox3').fadeOut(2000, function () {
          if (list[n][3]) {
            if (that.$refs.div_id3) {
              that.$refs.div_id3[0].style.opacity = 1
            }
            that.listHandled[3] = list[n][3]
          } else {
            if (that.$refs.div_id3) {
              that.$refs.div_id3[0].style.opacity = 0
            }
          }
          $(this).fadeIn(2000)
        })
        $('#div_innerbox4').fadeOut(2000, function () {
          if (list[n][4]) {
            if (that.$refs.div_id4) {
              that.$refs.div_id4[0].style.opacity = 1
            }
            that.listHandled[4] = list[n][4]
          } else {
            if (that.$refs.div_id4) {
              that.$refs.div_id4[0].style.opacity = 0
            }
          }
          $(this).fadeIn(2000)
        })
      }, 2 * time)

      this.timer3 = setTimeout(function () {
        $('#div_innerbox5').fadeOut(2000, function () {
          if (list[n][5]) {
            if (that.$refs.div_id5) {
              that.$refs.div_id5[0].style.opacity = 1
            }
            that.listHandled[5] = list[n][5]
          } else {
            if (that.$refs.div_id5) {
              that.$refs.div_id5[0].style.opacity = 0
            }
          }
          $(this).fadeIn(2000)
        })
      }, 3 * time)

      this.timer4 = setTimeout(function () {
        let tmpIndex = pageIndex + 1
        that.pageChange(list, tmpIndex, time)
      }, 10000 + 3 * time + 2000 + 2000)
    },
    chunk(arr, size) {
      var arr2 = []
      for (var i = 0; i < arr.length; i = i + size) {
        arr2.push(arr.slice(i, i + size))
      }
      return arr2
    },
    increaseIndex(list, index) {
      if (this.listTimer) {
        clearTimeout(this.listTimer)
      }
      this.listHandled = list[index]
      if (index === list.length - 1) {
        index = 0
      } else {
        index++
      }
      this.listTimer = setTimeout(() => this.increaseIndex(list, index), 1000 * 60)
    },
    startCEMSCardAnimate() {
      if (this.animateTimer) {
        clearTimeout(this.animateTimer)
      }
      if (this.timer1) {
        clearTimeout(this.timer1)
      }
      if (this.timer2) {
        clearTimeout(this.timer2)
      }
      if (this.timer3) {
        clearTimeout(this.timer3)
      }
      if (this.timer4) {
        clearTimeout(this.timer4)
      }
      if (this.timer5) {
        clearTimeout(this.timer5)
      }

      let dom_1 = `#div_innerbox0`
      let dom_2 = `#div_innerbox1`
      let dom_3 = `#div_innerbox2`
      let dom_4 = `#div_innerbox3`
      let dom_5 = `#div_innerbox4`
      let dom_6 = `#div_innerbox5`

      $(dom_1).fadeOut(2000, () => {
        $(dom_1).fadeIn(2000)
      })
      this.timer1 = setTimeout(() => {
        $(dom_2).fadeOut(2000, () => {
          $(dom_2).fadeIn(2000)
        })
      }, 500)
      this.timer2 = setTimeout(() => {
        $(dom_3).fadeOut(2000, () => {
          $(dom_3).fadeIn(2000)
        })
      }, 1000)
      this.timer3 = setTimeout(() => {
        $(dom_4).fadeOut(2000, () => {
          $(dom_4).fadeIn(2000)
        })
      }, 1500)
      this.timer4 = setTimeout(() => {
        $(dom_5).fadeOut(2000, () => {
          $(dom_5).fadeIn(2000)
        })
      }, 2000)
      this.timer5 = setTimeout(() => {
        $(dom_6).fadeOut(2000, () => {
          $(dom_6).fadeIn(2000)
        })
      }, 2500)
      this.animateTimer = setTimeout(() => {
        this.startCEMSCardAnimate()
        if (this.curIndex === 5) {
          this.curIndex = 0
        } else {
          this.curIndex++
        }
      }, 6000)
    },

    sliceList(list, size) {
      console.log(list, size)
      let length = Math.ceil(list.length / size)
      let tmpList = []
      for (let i = 0; i < length; i++) {
        let tmpArr = list.slice(i * size, (i + 1) * size)
        tmpList[i] = tmpArr
      }
      console.log(tmpList, 'tmpList')
      this.increaseIndex(tmpList, 0)
    },

    //点击弹窗
    getDetailPup(deviceNo, item) {
      this.selectDeviceNo = deviceNo
      if (item.lat && item.lon) {
        let positionArr = [(item.lon * 2 * Math.PI) / 360, (item.lat * 2 * Math.PI) / 360, this.altitude + 45]
        g_bme3dManager.earth.camera.flyTo(positionArr, this.flyAltitude + 450, undefined, 2)
      }
      this.envLiClick(deviceNo)
      // setTimeout(() => {
      //   this.getinventoryId(deviceNo);
      // }, 2000);
    },
    async getinventoryId(device_no) {
      let findCemsDetailsInfo = CONFIG.requestName + this.$apiOpt.findCemsDetailsInfo
      let data = await this.$apiUtils.get(findCemsDetailsInfo, {
        deviceNo: device_no
      })
      if (data) {
        this.$store.commit('dialogStatus', true)
        this.$popup.open(iframePup, this.dialogCompontent, this, {
          dialog: `${window.bmeConfig.baseUrlHttp}/standard/${window.CONFIG.requestName}/page/organized/org_manage.html?customerId=${this.customerId}&inventoryId=${data.emission_source_no}&style=${this.styleType}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '')
        })
      }
    },

    envLiClick(item) {
      let sn_index = 0
      g_bme3dManager._cemsManager._pois._entites.find((x, index) => {
        if (x._xbsjGuid == item) {
          sn_index = index
        }
      })
      //图标放大
      let time = 3000
      for (var i = 0; i < 4; i++) {
        setTimeout(() => {
          //CEMS
          g_bme3dManager._cemsManager._pois._entites[sn_index].billboard.scale = 0.8
        }, time + 1000 * i)
        setTimeout(() => {
          //CEMS
          g_bme3dManager._cemsManager._pois._entites[sn_index].billboard.scale = 0.6
        }, time + 500 + 1000 * i)
      }
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.cemsPublicity {
  width: 1240px;
  height: 790px;
  .div_outbox {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: row wrap;
    height: 100%;
    justify-content: space-between;
    .div_innerbox {
      position: relative;
      width: 600px !important;
      height: 250px !important;
      margin-bottom: 20px;
      margin-right: 20px;
      .boxbg {
        @include bg-box(600px, 250px, 'panelView_blackBg_2_1.png');
        position: absolute;
        top: 0px;
        left: 0px;
        &.hx_bg {
          @include bg-box(600px, 250px, 'panelView_blackBg_2_1.png');
        }
        &.isBaoSteel {
          @include bg-box(600px, 250px, 'panelView_baoSteel_2_1.png');
        }
        .hover-bg {
          position: absolute;
          left: 0px;
          right: 0px;
          top: 0px;
          bottom: 0px;
          background-image: none;
          box-shadow: none;
        }
      }
      .box-bg-89 {
        @include bg-box(600px, 250px, 'panelView_strong_Bg_89_2_1.png');
      }
      .cemsSel {
        .hover-bg {
          position: absolute;
          left: 0px;
          right: 0px;
          top: 0px;
          bottom: 0px;
          background-image: url('./img/3.png');
          box-shadow: 4px 4px 20px 0px #5bb4ff;
        }
      }
      .name {
        position: absolute;
        font-weight: 500;
        color: #e2effd;
        line-height: 20px;
        font-size: 20px;
        font-family: 'fontNormal';
        top: 20px;
        left: 30px;
        img {
          display: inline-block;
          vertical-align: middle;
        }
        span {
          font-size: 20px;
          font-family: 'fontNormal';
          margin-left: 10px;
          vertical-align: middle;
        }
      }
      .time {
        position: absolute;
        font-size: 20px;
        top: 20px;
        right: 30px;
        font-family: 'number';
        font-weight: 300;
        color: #51eeff;
        line-height: 20px;
      }
      .txtContent {
        position: relative;
        width: 100%;
        margin-top: 67px;
        padding-left: 29px;
        .textTitle {
          position: absolute;
          display: flex;
          top: -10px;
          right: 20px;
          .title1 {
            margin-right: 120px;
            font-size: 16px;
            font-family: 'fontNormal';
            font-weight: 400;
            color: #888888;
            line-height: 20px;
          }
          .title2 {
            margin-right: 47px;
            font-size: 16px;
            font-family: 'fontNormal';
            font-weight: 400;
            color: #888888;
            line-height: 20px;
          }
        }
        .textTable {
          width: 95%;
          padding-top: 20px;

          table {
            border-color: #00bcd41a;
            background: linear-gradient(
              180deg,
              rgba(2, 114, 225, 0) 0%,
              rgb(2 124 225 / 11%) 51%,
              rgba(1, 124, 191, 0) 99%,
              rgba(1, 191, 165, 0) 100%
            );
            background-image: url('./img/2.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        .textList {
          display: flex;
          align-items: center; /*垂直居中*/
          // justify-content: center; /*水平居中*/
          .listName {
            width: 30%;
            // text-align: center;
            font-size: 24px;
            color: #ffffff;
          }
          .listNum {
            width: 35%;
            text-align: center;
            font-size: 36px;
            font-weight: 500;
            color: #02fcff;
            text-shadow: 0px 2px 6px #0091ff;
            line-height: 44px;
            height: 44px;
            white-space: nowrap;
            span {
              margin-left: 18px;
              font-size: 20px;
              color: #ffffff;
              line-height: 44px;
              height: 44px;
              vertical-align: top;
              display: inline-block;
            }
          }
          .listNum2 {
            white-space: nowrap;
            width: 35%;
            text-align: center;
            font-size: 36px;
            font-weight: 500;
            color: #fff;
            span {
              margin-left: 18px;
              font-size: 20px;
              color: #ffffff;
            }
          }
        }
        tr td {
          width: 186px;
          height: 45px;
          line-height: 45px;
          text-align: center;
        }
        .listName {
          font-size: 16px;
          font-family: 'fontNormal';
          font-weight: 400;
          color: #47ffdd;
          line-height: 20px;
        }
        .blueColor {
          color: #99f5ff;
          font-size: 26px;
          padding: 0 15px;
        }
        .yellowColor {
          color: #f4c48f;
          font-size: 26px;
          padding: 0 15px;
        }
        .redColor {
          color: #ff7373;
          font-size: 26px;
          padding: 0 15px;
        }
        .normalColor {
          color: #ffffff;
          font-size: 26px;
          padding: 0 15px;
        }
      }
      &:nth-of-type(1) {
      }
    }
  }
}
.tinyName {
  display: inline-block;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
